export const queryKeys = {
  GET_STATS: 'GET_STATS'
};
